import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const postUserData = async (data) => {
  const response = await axios({
    url: '/user',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  });
  return response.data;
};

const usePostUser = () => {
  return useMutation((data) => postUserData(data));
};

export default usePostUser;
